import React, { useEffect } from 'react'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { VirtualTour } from 'Containers/virtualTour'
import { IMap } from 'Containers/imap'
import { Container } from '@mui/material'
import { setAppMode } from 'Slices/AppModeSlice'
import { setLocation } from 'Slices/LocationSlice'
import {
  useGetLocationsQuery,
  useGetLocationsInfoQuery,
  useGetStopsQuery,
} from 'Services/institution'

export const HomeContainer = () => {
  const dispatch = useDispatch()

  const params = useParams()
  const { instId, appMode } = params
  let { locId } = params

  if (!locId) {
    const { data: instData } = useGetLocationsQuery({ instId })
    locId = instData?.resources?.data?.find(loc => loc.status === 'live')?.loc_id
  }

  const { data: locData } = useGetLocationsInfoQuery(
    {
      instId,
      locId,
    },
    { skip: !locId }
  )

  const [searchParams] = useSearchParams()
  const isDirect = searchParams.get('from') === 'direct'
  let tourId = searchParams.get('tourid')
  if (!tourId) {
    const { data: tourStopsData } = useGetStopsQuery({
      instId,
      locId,
    })
    tourId = Object.keys(tourStopsData?.resources || {})[0]
  }

  const navigate = useNavigate()

  dispatch(setAppMode(appMode === 'ada' ? 'tour' : 'map'))
  dispatch(
    setLocation({
      instId,
      locId,
      tourId,
      instName: locData?.resources.name,
    })
  )

  useEffect(() => {
    if (!isDirect) {
      const redirectUrl = `${process.env.REACT_APP_BASE_URL}/tour/${instId}/${locId}`
      const referrer = document.referrer.match('youvisit')
      if (!referrer) window.location.replace(redirectUrl)
    }
  }, [isDirect, instId, locId, navigate])

  const mode = useSelector((state: any) => state.appMode)

  return (
    locData?.resources.name && (
      <Container maxWidth='lg' data-testid='home-container'>
        {mode === 'tour' ? <VirtualTour /> : <IMap />}
      </Container>
    )
  )
}
